module.exports = __webpack_public_path__ + "static/media/zomerblik_1.000c0966.jpeg";